"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
/* eslint-disable no-undef */
// @ts-nocheck
var react_1 = __importDefault(require("react"));
var draft_js_1 = require("draft-js");
var generateActions = function (alignment, isAlignmentDropdownOpen, setAlignmentDropdownOpen) { return [
    {
        label: "Bold",
        style: "BOLD",
        icon: "fas fa-bold",
        type: ACTION_TYPE.INLINE
    },
    {
        label: "Italic",
        style: "ITALIC",
        icon: "fas fa-italic",
        type: ACTION_TYPE.INLINE
    },
    { label: "Link", icon: "fas fa-link", type: ACTION_TYPE.MODAL },
    {
        label: "Blockquote",
        style: "blockquote",
        icon: "fas fa-quote-right",
        type: ACTION_TYPE.BLOCK
    },
    {
        label: "Unordered list",
        style: "unordered-list-item",
        icon: "fas fa-list-ul",
        type: ACTION_TYPE.BLOCK
    },
    {
        label: "Ordered list",
        style: "ordered-list-item",
        icon: "fas fa-list-ol",
        type: ACTION_TYPE.BLOCK
    },
    {
        label: "Align left",
        icon: "fas fa-align-left",
        style: "left",
        cssClass: alignment,
        stateVariable: isAlignmentDropdownOpen,
        stateFn: setAlignmentDropdownOpen,
        type: ACTION_TYPE.BLOCK,
        actions: [
            {
                label: "Align left",
                style: "left",
                icon: "fas fa-align-left",
                type: ACTION_TYPE.BLOCK
            },
            {
                label: "Align center",
                style: "center",
                icon: "fas fa-align-center",
                type: ACTION_TYPE.BLOCK
            },
            {
                label: "Align right",
                style: "right",
                icon: "fas fa-align-right",
                type: ACTION_TYPE.BLOCK
            },
        ]
    },
]; };
exports.generateActions = generateActions;
var getClassnames = function (action, editorState) {
    var currentInlineStyle = editorState.getCurrentInlineStyle();
    // inline style
    if (currentInlineStyle.size > 0 && currentInlineStyle.has(action.style)) {
        return "editor-view__inlinetoolbar--item editor-view__inlinetoolbar--item__active";
    }
    // block style
    var currentBlockType = draft_js_1.RichUtils.getCurrentBlockType(editorState);
    if (currentBlockType === action.style) {
        return "editor-view__inlinetoolbar--item editor-view__inlinetoolbar--item__active";
    }
    return "editor-view__inlinetoolbar--item";
};
exports.getClassnames = getClassnames;
var generateToolbar = function (actions, editorState, handleAction) {
    return actions.map(function (action, index) {
        if (action.actions) {
            var currentBlockType = draft_js_1.RichUtils.getCurrentBlockType(editorState);
            var currentBlockAction = getCurrentBlockAction(action, currentBlockType);
            return (react_1["default"].createElement("div", { key: [action, index].join("-"), className: action.cssClass, onMouseDown: function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                    action.stateFn(!action.stateVariable);
                }, role: "button" },
                react_1["default"].createElement("div", { className: "editor-view__inlinetoolbar--more", key: [action, index, currentBlockAction].join("-") },
                    react_1["default"].createElement("span", null, currentBlockAction && react_1["default"].createElement("i", { className: currentBlockAction.icon }))),
                action.stateVariable && (react_1["default"].createElement("div", { className: "editor-view__inlinetoolbar--submenu__actions" }, generateToolbarActions(action, handleAction, editorState)))));
        }
        var className = getClassnames(action, editorState);
        return (react_1["default"].createElement("div", { className: className, role: "button", alt: action.label, "aria-label": action.label, onMouseDown: function (e) {
                e.stopPropagation();
                e.preventDefault();
                handleAction({ action: action });
            } },
            react_1["default"].createElement("i", { className: action.icon })));
    });
};
exports.generateToolbar = generateToolbar;
var generateToolbarActions = function (root, handleAction, editorState) {
    return root.actions.map(function (action, index) {
        var className = getClassnames(action, editorState);
        return (react_1["default"].createElement("div", { key: [action.label, index].join("-"), className: className, role: "button", alt: action.label, "aria-label": action.label, onMouseDown: function (e) {
                e.preventDefault();
                e.stopPropagation();
                handleAction({ e: e, action: action });
            } },
            react_1["default"].createElement("i", { className: action.icon })));
    });
};
exports.generateToolbarActions = generateToolbarActions;
var ACTION_TYPE = {
    INLINE: "inline",
    BLOCK: "block",
    ATOMIC: "atomic",
    MODAL: "modal"
};
exports.ACTION_TYPE = ACTION_TYPE;
var ENTITY = {
    HORIZONTAL_RULE: {
        type: "HORIZONTAL_RULE",
        mutability: "IMMUTABLE",
        data: {}
    }
};
exports.ENTITY = ENTITY;
var getCurrentBlockAction = function (action, currentBlockStyle) {
    if (currentBlockStyle === "unstyled" ||
        currentBlockStyle.includes("header") ||
        currentBlockStyle.includes("blockquote") ||
        currentBlockStyle.includes("unordered-list-item") ||
        currentBlockStyle.includes("ordered-list-item")) {
        return action.actions[0];
    }
    var result = action.actions.filter(function (item) { return item.style === currentBlockStyle; });
    return result[0];
};
exports.getCurrentBlockAction = getCurrentBlockAction;
var getCurrentBlockTypeLabel = function (editorState) {
    var currentBlockType = draft_js_1.RichUtils.getCurrentBlockType(editorState);
    switch (currentBlockType) {
        case "unstyled":
            return "Paragraph";
        case "header-one":
            return "Heading 1";
        case "header-two":
            return "Heading 2";
        case "header-three":
            return "Heading 3";
        case "header-four":
            return "Heading 4";
        case "header-five":
            return "Heading 5";
        case "header-six":
            return "Heading 6";
        default:
            return "Paragraph";
    }
};
exports.getCurrentBlockTypeLabel = getCurrentBlockTypeLabel;
var getInlineToolbarLeftPosition = function (rect, selectionRect) {
    var toolbarSize = 500;
    var padding = 60;
    var left = selectionRect.left, right = selectionRect.right;
    if (toolbarSize > rect.width) {
        return -(padding / 2);
    }
    // left
    if (left === rect.x) {
        return left - rect.x;
    }
    if (left < toolbarSize) {
        return left - rect.x;
    }
    // right
    if (right > rect.width) {
        return rect.width - toolbarSize - padding / 2;
    }
    return left - toolbarSize;
};
exports.getInlineToolbarLeftPosition = getInlineToolbarLeftPosition;
var getInlineToolbarTopPosition = function (selectionRect) {
    var inlineToolbarHeight = 300;
    return selectionRect.top - inlineToolbarHeight;
};
exports.getInlineToolbarTopPosition = getInlineToolbarTopPosition;
function RectObject() {
    this.rect = {
        x: 0,
        y: 0,
        width: 0
    };
}
var Rect = new RectObject();
exports.Rect = Rect;
